import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { fetchDashboardStats } from 'slices/dashboard/dashboardSlice';
import { AppDispatch } from 'slices/app/store/store';

const CountData = () => {
      const dispatch = useDispatch<AppDispatch>();
    
    const [storeId, setStoreId] = useState(localStorage.getItem("storedataid"));

    useEffect(() => {
        const interval = setInterval(() => {
            const current = localStorage.getItem("storedataid");
            if (current !== storeId) {
                setStoreId(current);
            }
        }, 500); // poll for change every 500ms

        return () => clearInterval(interval);
    }, [storeId]);

    useEffect(() => {
        if (!storeId) return;

        const loadStats = async () => {
            await dispatch(fetchDashboardStats());
        };

        loadStats();
    }, [storeId, dispatch]);

    return null
}

export default CountData
